import { Modal, ModalProps, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import {
  BankConnectionErrorBody,
  BankConnectionErrorType,
} from '@features/bankAccounts/elements/BankConnectionErrorBody'

import { ModalId } from '../../../../../../enums/modalId'

interface ErrorModalProps extends ModalProps {
  removeQueryParams: () => void
}

export const ErrorModal = ({ removeQueryParams, ...modalProps }: ErrorModalProps): ReactElement => {
  const { close: closeModal } = useModal(ModalId.BankConnectionErrorModal)

  const handleCloseModal = useCallback(() => {
    removeQueryParams()
    closeModal()
  }, [closeModal, removeQueryParams])

  return (
    <Modal size="s" {...modalProps} closable={false}>
      <BankConnectionErrorBody errorType={BankConnectionErrorType.OpenBankingConnect} onClose={handleCloseModal} />
    </Modal>
  )
}
